import {Injectable} from "@angular/core";

export type SubscriptionMetadataDefinition = {
    label: string;
    type?: "string" | "number" | "boolean" | "select";
    options?: { value: string; label: string }[];
    min?: number;
    max?: number;
}

export type SubscriptionMetadataSectionDefinition = {
    label: string;
};

export type SubscriptionMetadataDefinitionRegistryData = Record<string, {
    label: string;
    fields: Record<string, SubscriptionMetadataDefinition>;
}>;

@Injectable({
    providedIn: 'root'
})
export class SubscriptionMetadataDefinitionRegistry {
    private data: SubscriptionMetadataDefinitionRegistryData = {};

    public register(metadata: SubscriptionMetadataDefinitionRegistryData) {
        for (const [section, definition] of Object.entries(metadata)) {
            this.data[section] = {
                label: definition.label ?? this.data[section]?.label ?? section,
                fields: {
                    ...(this.data[section]?.fields ?? {}),
                    ...definition.fields,
                },
            };
        }
    }

    public getFieldDefinition(
        section: string,
        key: string
    ): SubscriptionMetadataDefinition | undefined {
        return this.data[section]?.fields?.[key];
    }

    public getSectionDefinition(
        section: string
    ): SubscriptionMetadataSectionDefinition | undefined {
        return this.data[section]
            ? { label: this.data[section].label }
            : undefined;
    }

}
